export const SHOP_URL = "https://captainscut.com/shop";

// Backend address resolution order:
// 1. build-time env (Emergent preview/production builds)
// 2. runtime /site-config.js (static hosts such as Hostinger, where the env var may be absent)
// 3. the page's own origin (same-origin deployments)
const envUrl = process.env.REACT_APP_BACKEND_URL;
export const BACKEND_URL =
  (envUrl && envUrl !== "undefined" && envUrl) || window.CC_BACKEND_URL || window.location.origin;
export const API = `${BACKEND_URL}/api`;

export const scrollToId = (id) => {
  const target = document.querySelector(id);
  if (!target) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(target, { offset: -70, duration: 1.4 });
  } else {
    target.scrollIntoView({ behavior: "smooth" });
  }
};
